import { Injectable } from '@angular/core';

import { SnackbarService } from './snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  constructor(private snackbarService: SnackbarService) {}

  async copy(text: string): Promise<void> {
    try {
      await this.writeToClipboard(text);
      this.snackbarService.show({
        role: 'success',
        text: 'Copied to clipboard.',
        duration: 'short',
      });
    } catch (error) {
      this.snackbarService.show({
        role: 'error',
        text: 'Something went wrong.',
        duration: 'long',
      });
      throw error;
    }
  }

  private writeToClipboard(text: string): Promise<void> {
    if (!navigator.clipboard?.writeText) {
      throw new Error('Clipboard API is not available');
    }

    return navigator.clipboard.writeText(text);
  }
}
